// redux snackbar is deprecated, use @skillzet/components/SnackbarContainer
import { IActionOptionalData } from '@app/common/interfaces';

export enum SNACK_BAR {
  OPEN_SNACKBAR = 'snackBar/OPEN_SNACKBAR',
  CLOSE_SNACKBAR = 'snackBar/CLOSE_SNACKBAR',
}

// TODO FIX [WS-16404] this issue. Keeping openSnackbar in this causes caused the following error
// moving the function into common/actions/index.ts somehow resolves the issue
// index.ts:38 Uncaught TypeError: Cannot read property 'openSnackbar' of undefined
//     at Module.openSnackbar (index.ts:38)
//     at eval (index.ts:331)
//     at Module.../frontend/common/components/AnalyticsSummaryCard/index.ts (main-2e9aec0377ed9c4a9ea6.js:459)
//     at __webpack_require__ (main-2e9aec0377ed9c4a9ea6.js:4346)
//     at eval (index.ts:40)
//     at Module.../frontend/common/components/index.ts (main-2e9aec0377ed9c4a9ea6.js:778)
//     at __webpack_require__ (main-2e9aec0377ed9c4a9ea6.js:4346)
//     at eval (chartHelper.tsx:12)
//     at Module.../frontend/common/helpers/chartHelper.tsx (main-2e9aec0377ed9c4a9ea6.js:998)
//     at __webpack_require__ (main-2e9aec0377ed9c4a9ea6.js:4346)

// export function openSnackbar(options: ISnackbarData): IAction<ISnackbarData> {
//   return {
//     type: SNACK_BAR.OPEN_SNACKBAR,
//     data: options,
//   };
// }

export function closeSnackbar(): IActionOptionalData {
  return {
    type: SNACK_BAR.CLOSE_SNACKBAR,
  };
}
